module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Изменение платёжного периода","select":"Изменение платёжного периода вступит в силу после завершения текущего оплаченного периода. Выбор влияет на сумму списания при продлении подписки, прямо сейчас с вашей карты ничего не будет списано."}}')
  delete Component.options._Ctor
}
